import { Controller } from "@hotwired/stimulus";

// Mirrors a Forms::ColorPickerComponent's swatch <input type="color">
// and its hex text field. The branding editor syncs these through its
// app-preview controller; every other surface (funnel Colors card)
// relies on this one. Rides on the component root, so it composes with
// app-preview where both are present.
export default class extends Controller {
  connect() {
    this.swatch = this.element.querySelector("input[type=color]");
    this.text = this.element.querySelector("input[type=text]");
    if (!this.swatch || !this.text) return;

    this.swatch.addEventListener("input", () => {
      this.text.value = this.swatch.value.replace("#", "").toLowerCase();
    });
    this.text.addEventListener("input", () => {
      const hex = this.text.value.trim().replace("#", "");
      if (/^[0-9a-fA-F]{6}$/.test(hex)) this.swatch.value = `#${hex}`;
    });
  }
}
